export default __webpack_public_path__ + "static/img/desktopdog.f8d6ba9.png";